/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PasswordRouteImport } from './routes/password'
import { Route as TotpSetupRouteImport } from './routes/totp-setup'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as DevComponentsRouteImport } from './routes/[_]dev/components'
import { Route as DevMapRouteImport } from './routes/[_]dev/map'
import { Route as AppActivityIndexRouteImport } from './routes/_app/activity/index'
import { Route as AppActivityDeliveriesRouteImport } from './routes/_app/activity/deliveries'
import { Route as AppActivityJobsRouteImport } from './routes/_app/activity/jobs'
import { Route as AppActivityNotificationsRouteImport } from './routes/_app/activity/notifications'
import { Route as AppCarriersIndexRouteImport } from './routes/_app/carriers/index'
import { Route as AppCarriersCodeRouteImport } from './routes/_app/carriers/$code'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsLocationsRouteImport } from './routes/_app/settings/locations'
import { Route as AppSettingsMigrationRouteImport } from './routes/_app/settings/migration'
import { Route as AppSettingsPassagesRouteImport } from './routes/_app/settings/passages'
import { Route as AppSettingsRulesRouteImport } from './routes/_app/settings/rules'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppShipmentsIndexRouteImport } from './routes/_app/shipments/index'
import { Route as AppShipmentsIdRouteImport } from './routes/_app/shipments/$id'
import { Route as AppShipmentsApproveRouteImport } from './routes/_app/shipments/approve'
import { Route as AppShipmentsAttentionRouteImport } from './routes/_app/shipments/attention'
import { Route as AppShipmentsCompareRouteImport } from './routes/_app/shipments/compare'
import { Route as AppShipmentsImportRouteImport } from './routes/_app/shipments/import'
import { Route as AppShipmentsNotesRouteImport } from './routes/_app/shipments/notes'
import { Route as AppCarriersCodeIndexRouteImport } from './routes/_app/carriers/$code/index'
import { Route as AppCarriersCodeActivityRouteImport } from './routes/_app/carriers/$code/activity'
import { Route as AppCarriersCodePreferencesRouteImport } from './routes/_app/carriers/$code/preferences'
import { Route as AppCarriersCodeProposalsRouteImport } from './routes/_app/carriers/$code/proposals'
import { Route as AppCarriersCodeRecipesRouteImport } from './routes/_app/carriers/$code/recipes'
import { Route as AppCarriersCodeShipmentsRouteImport } from './routes/_app/carriers/$code/shipments'
import { Route as AppShipmentsIdIndexRouteImport } from './routes/_app/shipments/$id/index'
import { Route as AppShipmentsIdDeliveriesRouteImport } from './routes/_app/shipments/$id/deliveries'
import { Route as AppShipmentsIdHistoryRouteImport } from './routes/_app/shipments/$id/history'
import { Route as AppShipmentsIdReadsRouteImport } from './routes/_app/shipments/$id/reads'
import { Route as AppShipmentsIdReviewRouteImport } from './routes/_app/shipments/$id/review'
import { Route as AppShipmentsIdChar91routeChar93RouteImport } from './routes/_app/shipments/$id/[route]'
import { Route as AppShipmentsIdTimelineRouteImport } from './routes/_app/shipments/$id/timeline'
import { Route as CarriersCodeRecipesVersionEditRouteImport } from './routes/carriers/$code/recipes/$version/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordRoute = PasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => rootRouteImport,
} as any)
const TotpSetupRoute = TotpSetupRouteImport.update({
  id: '/totp-setup',
  path: '/totp-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/_dev/components',
  path: '/_dev/components',
  getParentRoute: () => rootRouteImport,
} as any)
const DevMapRoute = DevMapRouteImport.update({
  id: '/_dev/map',
  path: '/_dev/map',
  getParentRoute: () => rootRouteImport,
} as any)
const AppActivityIndexRoute = AppActivityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppActivityRoute,
} as any)
const AppActivityDeliveriesRoute = AppActivityDeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => AppActivityRoute,
} as any)
const AppActivityJobsRoute = AppActivityJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppActivityRoute,
} as any)
const AppActivityNotificationsRoute =
  AppActivityNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppActivityRoute,
  } as any)
const AppCarriersIndexRoute = AppCarriersIndexRouteImport.update({
  id: '/carriers/',
  path: '/carriers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCarriersCodeRoute = AppCarriersCodeRouteImport.update({
  id: '/carriers/$code',
  path: '/carriers/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLocationsRoute = AppSettingsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMigrationRoute = AppSettingsMigrationRouteImport.update({
  id: '/migration',
  path: '/migration',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPassagesRoute = AppSettingsPassagesRouteImport.update({
  id: '/passages',
  path: '/passages',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRulesRoute = AppSettingsRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppShipmentsIndexRoute = AppShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsIdRoute = AppShipmentsIdRouteImport.update({
  id: '/shipments/$id',
  path: '/shipments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsApproveRoute = AppShipmentsApproveRouteImport.update({
  id: '/shipments/approve',
  path: '/shipments/approve',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsAttentionRoute = AppShipmentsAttentionRouteImport.update({
  id: '/shipments/attention',
  path: '/shipments/attention',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsCompareRoute = AppShipmentsCompareRouteImport.update({
  id: '/shipments/compare',
  path: '/shipments/compare',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsImportRoute = AppShipmentsImportRouteImport.update({
  id: '/shipments/import',
  path: '/shipments/import',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsNotesRoute = AppShipmentsNotesRouteImport.update({
  id: '/shipments/notes',
  path: '/shipments/notes',
  getParentRoute: () => AppRoute,
} as any)
const AppCarriersCodeIndexRoute = AppCarriersCodeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCarriersCodeRoute,
} as any)
const AppCarriersCodeActivityRoute = AppCarriersCodeActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppCarriersCodeRoute,
} as any)
const AppCarriersCodePreferencesRoute =
  AppCarriersCodePreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AppCarriersCodeRoute,
  } as any)
const AppCarriersCodeProposalsRoute =
  AppCarriersCodeProposalsRouteImport.update({
    id: '/proposals',
    path: '/proposals',
    getParentRoute: () => AppCarriersCodeRoute,
  } as any)
const AppCarriersCodeRecipesRoute = AppCarriersCodeRecipesRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => AppCarriersCodeRoute,
} as any)
const AppCarriersCodeShipmentsRoute =
  AppCarriersCodeShipmentsRouteImport.update({
    id: '/shipments',
    path: '/shipments',
    getParentRoute: () => AppCarriersCodeRoute,
  } as any)
const AppShipmentsIdIndexRoute = AppShipmentsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppShipmentsIdRoute,
} as any)
const AppShipmentsIdDeliveriesRoute =
  AppShipmentsIdDeliveriesRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AppShipmentsIdRoute,
  } as any)
const AppShipmentsIdHistoryRoute = AppShipmentsIdHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppShipmentsIdRoute,
} as any)
const AppShipmentsIdReadsRoute = AppShipmentsIdReadsRouteImport.update({
  id: '/reads',
  path: '/reads',
  getParentRoute: () => AppShipmentsIdRoute,
} as any)
const AppShipmentsIdReviewRoute = AppShipmentsIdReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppShipmentsIdRoute,
} as any)
const AppShipmentsIdChar91routeChar93Route =
  AppShipmentsIdChar91routeChar93RouteImport.update({
    id: '/route',
    path: '/route',
    getParentRoute: () => AppShipmentsIdRoute,
  } as any)
const AppShipmentsIdTimelineRoute = AppShipmentsIdTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AppShipmentsIdRoute,
} as any)
const CarriersCodeRecipesVersionEditRoute =
  CarriersCodeRecipesVersionEditRouteImport.update({
    id: '/carriers/$code/recipes/$version/edit',
    path: '/carriers/$code/recipes/$version/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/password': typeof PasswordRoute
  '/totp-setup': typeof TotpSetupRoute
  '/activity': typeof AppActivityRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/_dev/components': typeof DevComponentsRoute
  '/_dev/map': typeof DevMapRoute
  '/activity/deliveries': typeof AppActivityDeliveriesRoute
  '/activity/jobs': typeof AppActivityJobsRoute
  '/activity/notifications': typeof AppActivityNotificationsRoute
  '/carriers/$code': typeof AppCarriersCodeRouteWithChildren
  '/settings/locations': typeof AppSettingsLocationsRoute
  '/settings/migration': typeof AppSettingsMigrationRoute
  '/settings/passages': typeof AppSettingsPassagesRoute
  '/settings/rules': typeof AppSettingsRulesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/shipments/$id': typeof AppShipmentsIdRouteWithChildren
  '/shipments/approve': typeof AppShipmentsApproveRoute
  '/shipments/attention': typeof AppShipmentsAttentionRoute
  '/shipments/compare': typeof AppShipmentsCompareRoute
  '/shipments/import': typeof AppShipmentsImportRoute
  '/shipments/notes': typeof AppShipmentsNotesRoute
  '/activity/': typeof AppActivityIndexRoute
  '/carriers/': typeof AppCarriersIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shipments/': typeof AppShipmentsIndexRoute
  '/carriers/$code/activity': typeof AppCarriersCodeActivityRoute
  '/carriers/$code/preferences': typeof AppCarriersCodePreferencesRoute
  '/carriers/$code/proposals': typeof AppCarriersCodeProposalsRoute
  '/carriers/$code/recipes': typeof AppCarriersCodeRecipesRoute
  '/carriers/$code/shipments': typeof AppCarriersCodeShipmentsRoute
  '/shipments/$id/deliveries': typeof AppShipmentsIdDeliveriesRoute
  '/shipments/$id/history': typeof AppShipmentsIdHistoryRoute
  '/shipments/$id/reads': typeof AppShipmentsIdReadsRoute
  '/shipments/$id/review': typeof AppShipmentsIdReviewRoute
  '/shipments/$id/route': typeof AppShipmentsIdChar91routeChar93Route
  '/shipments/$id/timeline': typeof AppShipmentsIdTimelineRoute
  '/carriers/$code/': typeof AppCarriersCodeIndexRoute
  '/shipments/$id/': typeof AppShipmentsIdIndexRoute
  '/carriers/$code/recipes/$version/edit': typeof CarriersCodeRecipesVersionEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/password': typeof PasswordRoute
  '/totp-setup': typeof TotpSetupRoute
  '/_dev/components': typeof DevComponentsRoute
  '/_dev/map': typeof DevMapRoute
  '/activity/deliveries': typeof AppActivityDeliveriesRoute
  '/activity/jobs': typeof AppActivityJobsRoute
  '/activity/notifications': typeof AppActivityNotificationsRoute
  '/settings/locations': typeof AppSettingsLocationsRoute
  '/settings/migration': typeof AppSettingsMigrationRoute
  '/settings/passages': typeof AppSettingsPassagesRoute
  '/settings/rules': typeof AppSettingsRulesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/shipments/approve': typeof AppShipmentsApproveRoute
  '/shipments/attention': typeof AppShipmentsAttentionRoute
  '/shipments/compare': typeof AppShipmentsCompareRoute
  '/shipments/import': typeof AppShipmentsImportRoute
  '/shipments/notes': typeof AppShipmentsNotesRoute
  '/activity': typeof AppActivityIndexRoute
  '/carriers': typeof AppCarriersIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shipments': typeof AppShipmentsIndexRoute
  '/carriers/$code/activity': typeof AppCarriersCodeActivityRoute
  '/carriers/$code/preferences': typeof AppCarriersCodePreferencesRoute
  '/carriers/$code/proposals': typeof AppCarriersCodeProposalsRoute
  '/carriers/$code/recipes': typeof AppCarriersCodeRecipesRoute
  '/carriers/$code/shipments': typeof AppCarriersCodeShipmentsRoute
  '/shipments/$id/deliveries': typeof AppShipmentsIdDeliveriesRoute
  '/shipments/$id/history': typeof AppShipmentsIdHistoryRoute
  '/shipments/$id/reads': typeof AppShipmentsIdReadsRoute
  '/shipments/$id/review': typeof AppShipmentsIdReviewRoute
  '/shipments/$id/route': typeof AppShipmentsIdChar91routeChar93Route
  '/shipments/$id/timeline': typeof AppShipmentsIdTimelineRoute
  '/carriers/$code': typeof AppCarriersCodeIndexRoute
  '/shipments/$id': typeof AppShipmentsIdIndexRoute
  '/carriers/$code/recipes/$version/edit': typeof CarriersCodeRecipesVersionEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/password': typeof PasswordRoute
  '/totp-setup': typeof TotpSetupRoute
  '/_app/activity': typeof AppActivityRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_dev/components': typeof DevComponentsRoute
  '/_dev/map': typeof DevMapRoute
  '/_app/activity/deliveries': typeof AppActivityDeliveriesRoute
  '/_app/activity/jobs': typeof AppActivityJobsRoute
  '/_app/activity/notifications': typeof AppActivityNotificationsRoute
  '/_app/carriers/$code': typeof AppCarriersCodeRouteWithChildren
  '/_app/settings/locations': typeof AppSettingsLocationsRoute
  '/_app/settings/migration': typeof AppSettingsMigrationRoute
  '/_app/settings/passages': typeof AppSettingsPassagesRoute
  '/_app/settings/rules': typeof AppSettingsRulesRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/shipments/$id': typeof AppShipmentsIdRouteWithChildren
  '/_app/shipments/approve': typeof AppShipmentsApproveRoute
  '/_app/shipments/attention': typeof AppShipmentsAttentionRoute
  '/_app/shipments/compare': typeof AppShipmentsCompareRoute
  '/_app/shipments/import': typeof AppShipmentsImportRoute
  '/_app/shipments/notes': typeof AppShipmentsNotesRoute
  '/_app/activity/': typeof AppActivityIndexRoute
  '/_app/carriers/': typeof AppCarriersIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shipments/': typeof AppShipmentsIndexRoute
  '/_app/carriers/$code/activity': typeof AppCarriersCodeActivityRoute
  '/_app/carriers/$code/preferences': typeof AppCarriersCodePreferencesRoute
  '/_app/carriers/$code/proposals': typeof AppCarriersCodeProposalsRoute
  '/_app/carriers/$code/recipes': typeof AppCarriersCodeRecipesRoute
  '/_app/carriers/$code/shipments': typeof AppCarriersCodeShipmentsRoute
  '/_app/shipments/$id/deliveries': typeof AppShipmentsIdDeliveriesRoute
  '/_app/shipments/$id/history': typeof AppShipmentsIdHistoryRoute
  '/_app/shipments/$id/reads': typeof AppShipmentsIdReadsRoute
  '/_app/shipments/$id/review': typeof AppShipmentsIdReviewRoute
  '/_app/shipments/$id/route': typeof AppShipmentsIdChar91routeChar93Route
  '/_app/shipments/$id/timeline': typeof AppShipmentsIdTimelineRoute
  '/_app/carriers/$code/': typeof AppCarriersCodeIndexRoute
  '/_app/shipments/$id/': typeof AppShipmentsIdIndexRoute
  '/carriers/$code/recipes/$version/edit': typeof CarriersCodeRecipesVersionEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/password'
    | '/totp-setup'
    | '/activity'
    | '/settings'
    | '/_dev/components'
    | '/_dev/map'
    | '/activity/deliveries'
    | '/activity/jobs'
    | '/activity/notifications'
    | '/carriers/$code'
    | '/settings/locations'
    | '/settings/migration'
    | '/settings/passages'
    | '/settings/rules'
    | '/settings/users'
    | '/shipments/$id'
    | '/shipments/approve'
    | '/shipments/attention'
    | '/shipments/compare'
    | '/shipments/import'
    | '/shipments/notes'
    | '/activity/'
    | '/carriers/'
    | '/settings/'
    | '/shipments/'
    | '/carriers/$code/activity'
    | '/carriers/$code/preferences'
    | '/carriers/$code/proposals'
    | '/carriers/$code/recipes'
    | '/carriers/$code/shipments'
    | '/shipments/$id/deliveries'
    | '/shipments/$id/history'
    | '/shipments/$id/reads'
    | '/shipments/$id/review'
    | '/shipments/$id/route'
    | '/shipments/$id/timeline'
    | '/carriers/$code/'
    | '/shipments/$id/'
    | '/carriers/$code/recipes/$version/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/password'
    | '/totp-setup'
    | '/_dev/components'
    | '/_dev/map'
    | '/activity/deliveries'
    | '/activity/jobs'
    | '/activity/notifications'
    | '/settings/locations'
    | '/settings/migration'
    | '/settings/passages'
    | '/settings/rules'
    | '/settings/users'
    | '/shipments/approve'
    | '/shipments/attention'
    | '/shipments/compare'
    | '/shipments/import'
    | '/shipments/notes'
    | '/activity'
    | '/carriers'
    | '/settings'
    | '/shipments'
    | '/carriers/$code/activity'
    | '/carriers/$code/preferences'
    | '/carriers/$code/proposals'
    | '/carriers/$code/recipes'
    | '/carriers/$code/shipments'
    | '/shipments/$id/deliveries'
    | '/shipments/$id/history'
    | '/shipments/$id/reads'
    | '/shipments/$id/review'
    | '/shipments/$id/route'
    | '/shipments/$id/timeline'
    | '/carriers/$code'
    | '/shipments/$id'
    | '/carriers/$code/recipes/$version/edit'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/password'
    | '/totp-setup'
    | '/_app/activity'
    | '/_app/settings'
    | '/_dev/components'
    | '/_dev/map'
    | '/_app/activity/deliveries'
    | '/_app/activity/jobs'
    | '/_app/activity/notifications'
    | '/_app/carriers/$code'
    | '/_app/settings/locations'
    | '/_app/settings/migration'
    | '/_app/settings/passages'
    | '/_app/settings/rules'
    | '/_app/settings/users'
    | '/_app/shipments/$id'
    | '/_app/shipments/approve'
    | '/_app/shipments/attention'
    | '/_app/shipments/compare'
    | '/_app/shipments/import'
    | '/_app/shipments/notes'
    | '/_app/activity/'
    | '/_app/carriers/'
    | '/_app/settings/'
    | '/_app/shipments/'
    | '/_app/carriers/$code/activity'
    | '/_app/carriers/$code/preferences'
    | '/_app/carriers/$code/proposals'
    | '/_app/carriers/$code/recipes'
    | '/_app/carriers/$code/shipments'
    | '/_app/shipments/$id/deliveries'
    | '/_app/shipments/$id/history'
    | '/_app/shipments/$id/reads'
    | '/_app/shipments/$id/review'
    | '/_app/shipments/$id/route'
    | '/_app/shipments/$id/timeline'
    | '/_app/carriers/$code/'
    | '/_app/shipments/$id/'
    | '/carriers/$code/recipes/$version/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  PasswordRoute: typeof PasswordRoute
  TotpSetupRoute: typeof TotpSetupRoute
  DevComponentsRoute: typeof DevComponentsRoute
  DevMapRoute: typeof DevMapRoute
  CarriersCodeRecipesVersionEditRoute: typeof CarriersCodeRecipesVersionEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password': {
      id: '/password'
      path: '/password'
      fullPath: '/password'
      preLoaderRoute: typeof PasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/totp-setup': {
      id: '/totp-setup'
      path: '/totp-setup'
      fullPath: '/totp-setup'
      preLoaderRoute: typeof TotpSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_dev/components': {
      id: '/_dev/components'
      path: '/_dev/components'
      fullPath: '/_dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dev/map': {
      id: '/_dev/map'
      path: '/_dev/map'
      fullPath: '/_dev/map'
      preLoaderRoute: typeof DevMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/activity/': {
      id: '/_app/activity/'
      path: '/'
      fullPath: '/activity/'
      preLoaderRoute: typeof AppActivityIndexRouteImport
      parentRoute: typeof AppActivityRoute
    }
    '/_app/activity/deliveries': {
      id: '/_app/activity/deliveries'
      path: '/deliveries'
      fullPath: '/activity/deliveries'
      preLoaderRoute: typeof AppActivityDeliveriesRouteImport
      parentRoute: typeof AppActivityRoute
    }
    '/_app/activity/jobs': {
      id: '/_app/activity/jobs'
      path: '/jobs'
      fullPath: '/activity/jobs'
      preLoaderRoute: typeof AppActivityJobsRouteImport
      parentRoute: typeof AppActivityRoute
    }
    '/_app/activity/notifications': {
      id: '/_app/activity/notifications'
      path: '/notifications'
      fullPath: '/activity/notifications'
      preLoaderRoute: typeof AppActivityNotificationsRouteImport
      parentRoute: typeof AppActivityRoute
    }
    '/_app/carriers/': {
      id: '/_app/carriers/'
      path: '/carriers'
      fullPath: '/carriers/'
      preLoaderRoute: typeof AppCarriersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/carriers/$code': {
      id: '/_app/carriers/$code'
      path: '/carriers/$code'
      fullPath: '/carriers/$code'
      preLoaderRoute: typeof AppCarriersCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/locations': {
      id: '/_app/settings/locations'
      path: '/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof AppSettingsLocationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/migration': {
      id: '/_app/settings/migration'
      path: '/migration'
      fullPath: '/settings/migration'
      preLoaderRoute: typeof AppSettingsMigrationRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/passages': {
      id: '/_app/settings/passages'
      path: '/passages'
      fullPath: '/settings/passages'
      preLoaderRoute: typeof AppSettingsPassagesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/rules': {
      id: '/_app/settings/rules'
      path: '/rules'
      fullPath: '/settings/rules'
      preLoaderRoute: typeof AppSettingsRulesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/shipments/': {
      id: '/_app/shipments/'
      path: '/shipments'
      fullPath: '/shipments/'
      preLoaderRoute: typeof AppShipmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/$id': {
      id: '/_app/shipments/$id'
      path: '/shipments/$id'
      fullPath: '/shipments/$id'
      preLoaderRoute: typeof AppShipmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/approve': {
      id: '/_app/shipments/approve'
      path: '/shipments/approve'
      fullPath: '/shipments/approve'
      preLoaderRoute: typeof AppShipmentsApproveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/attention': {
      id: '/_app/shipments/attention'
      path: '/shipments/attention'
      fullPath: '/shipments/attention'
      preLoaderRoute: typeof AppShipmentsAttentionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/compare': {
      id: '/_app/shipments/compare'
      path: '/shipments/compare'
      fullPath: '/shipments/compare'
      preLoaderRoute: typeof AppShipmentsCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/import': {
      id: '/_app/shipments/import'
      path: '/shipments/import'
      fullPath: '/shipments/import'
      preLoaderRoute: typeof AppShipmentsImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/notes': {
      id: '/_app/shipments/notes'
      path: '/shipments/notes'
      fullPath: '/shipments/notes'
      preLoaderRoute: typeof AppShipmentsNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/carriers/$code/': {
      id: '/_app/carriers/$code/'
      path: '/'
      fullPath: '/carriers/$code/'
      preLoaderRoute: typeof AppCarriersCodeIndexRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/carriers/$code/activity': {
      id: '/_app/carriers/$code/activity'
      path: '/activity'
      fullPath: '/carriers/$code/activity'
      preLoaderRoute: typeof AppCarriersCodeActivityRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/carriers/$code/preferences': {
      id: '/_app/carriers/$code/preferences'
      path: '/preferences'
      fullPath: '/carriers/$code/preferences'
      preLoaderRoute: typeof AppCarriersCodePreferencesRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/carriers/$code/proposals': {
      id: '/_app/carriers/$code/proposals'
      path: '/proposals'
      fullPath: '/carriers/$code/proposals'
      preLoaderRoute: typeof AppCarriersCodeProposalsRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/carriers/$code/recipes': {
      id: '/_app/carriers/$code/recipes'
      path: '/recipes'
      fullPath: '/carriers/$code/recipes'
      preLoaderRoute: typeof AppCarriersCodeRecipesRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/carriers/$code/shipments': {
      id: '/_app/carriers/$code/shipments'
      path: '/shipments'
      fullPath: '/carriers/$code/shipments'
      preLoaderRoute: typeof AppCarriersCodeShipmentsRouteImport
      parentRoute: typeof AppCarriersCodeRoute
    }
    '/_app/shipments/$id/': {
      id: '/_app/shipments/$id/'
      path: '/'
      fullPath: '/shipments/$id/'
      preLoaderRoute: typeof AppShipmentsIdIndexRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/deliveries': {
      id: '/_app/shipments/$id/deliveries'
      path: '/deliveries'
      fullPath: '/shipments/$id/deliveries'
      preLoaderRoute: typeof AppShipmentsIdDeliveriesRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/history': {
      id: '/_app/shipments/$id/history'
      path: '/history'
      fullPath: '/shipments/$id/history'
      preLoaderRoute: typeof AppShipmentsIdHistoryRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/reads': {
      id: '/_app/shipments/$id/reads'
      path: '/reads'
      fullPath: '/shipments/$id/reads'
      preLoaderRoute: typeof AppShipmentsIdReadsRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/review': {
      id: '/_app/shipments/$id/review'
      path: '/review'
      fullPath: '/shipments/$id/review'
      preLoaderRoute: typeof AppShipmentsIdReviewRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/route': {
      id: '/_app/shipments/$id/route'
      path: '/route'
      fullPath: '/shipments/$id/route'
      preLoaderRoute: typeof AppShipmentsIdChar91routeChar93RouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/_app/shipments/$id/timeline': {
      id: '/_app/shipments/$id/timeline'
      path: '/timeline'
      fullPath: '/shipments/$id/timeline'
      preLoaderRoute: typeof AppShipmentsIdTimelineRouteImport
      parentRoute: typeof AppShipmentsIdRoute
    }
    '/carriers/$code/recipes/$version/edit': {
      id: '/carriers/$code/recipes/$version/edit'
      path: '/carriers/$code/recipes/$version/edit'
      fullPath: '/carriers/$code/recipes/$version/edit'
      preLoaderRoute: typeof CarriersCodeRecipesVersionEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppActivityRouteChildren {
  AppActivityDeliveriesRoute: typeof AppActivityDeliveriesRoute
  AppActivityJobsRoute: typeof AppActivityJobsRoute
  AppActivityNotificationsRoute: typeof AppActivityNotificationsRoute
  AppActivityIndexRoute: typeof AppActivityIndexRoute
}

const AppActivityRouteChildren: AppActivityRouteChildren = {
  AppActivityDeliveriesRoute: AppActivityDeliveriesRoute,
  AppActivityJobsRoute: AppActivityJobsRoute,
  AppActivityNotificationsRoute: AppActivityNotificationsRoute,
  AppActivityIndexRoute: AppActivityIndexRoute,
}

const AppActivityRouteWithChildren = AppActivityRoute._addFileChildren(
  AppActivityRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsLocationsRoute: typeof AppSettingsLocationsRoute
  AppSettingsMigrationRoute: typeof AppSettingsMigrationRoute
  AppSettingsPassagesRoute: typeof AppSettingsPassagesRoute
  AppSettingsRulesRoute: typeof AppSettingsRulesRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsLocationsRoute: AppSettingsLocationsRoute,
  AppSettingsMigrationRoute: AppSettingsMigrationRoute,
  AppSettingsPassagesRoute: AppSettingsPassagesRoute,
  AppSettingsRulesRoute: AppSettingsRulesRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppCarriersCodeRouteChildren {
  AppCarriersCodeActivityRoute: typeof AppCarriersCodeActivityRoute
  AppCarriersCodePreferencesRoute: typeof AppCarriersCodePreferencesRoute
  AppCarriersCodeProposalsRoute: typeof AppCarriersCodeProposalsRoute
  AppCarriersCodeRecipesRoute: typeof AppCarriersCodeRecipesRoute
  AppCarriersCodeShipmentsRoute: typeof AppCarriersCodeShipmentsRoute
  AppCarriersCodeIndexRoute: typeof AppCarriersCodeIndexRoute
}

const AppCarriersCodeRouteChildren: AppCarriersCodeRouteChildren = {
  AppCarriersCodeActivityRoute: AppCarriersCodeActivityRoute,
  AppCarriersCodePreferencesRoute: AppCarriersCodePreferencesRoute,
  AppCarriersCodeProposalsRoute: AppCarriersCodeProposalsRoute,
  AppCarriersCodeRecipesRoute: AppCarriersCodeRecipesRoute,
  AppCarriersCodeShipmentsRoute: AppCarriersCodeShipmentsRoute,
  AppCarriersCodeIndexRoute: AppCarriersCodeIndexRoute,
}

const AppCarriersCodeRouteWithChildren = AppCarriersCodeRoute._addFileChildren(
  AppCarriersCodeRouteChildren,
)

interface AppShipmentsIdRouteChildren {
  AppShipmentsIdDeliveriesRoute: typeof AppShipmentsIdDeliveriesRoute
  AppShipmentsIdHistoryRoute: typeof AppShipmentsIdHistoryRoute
  AppShipmentsIdReadsRoute: typeof AppShipmentsIdReadsRoute
  AppShipmentsIdReviewRoute: typeof AppShipmentsIdReviewRoute
  AppShipmentsIdChar91routeChar93Route: typeof AppShipmentsIdChar91routeChar93Route
  AppShipmentsIdTimelineRoute: typeof AppShipmentsIdTimelineRoute
  AppShipmentsIdIndexRoute: typeof AppShipmentsIdIndexRoute
}

const AppShipmentsIdRouteChildren: AppShipmentsIdRouteChildren = {
  AppShipmentsIdDeliveriesRoute: AppShipmentsIdDeliveriesRoute,
  AppShipmentsIdHistoryRoute: AppShipmentsIdHistoryRoute,
  AppShipmentsIdReadsRoute: AppShipmentsIdReadsRoute,
  AppShipmentsIdReviewRoute: AppShipmentsIdReviewRoute,
  AppShipmentsIdChar91routeChar93Route: AppShipmentsIdChar91routeChar93Route,
  AppShipmentsIdTimelineRoute: AppShipmentsIdTimelineRoute,
  AppShipmentsIdIndexRoute: AppShipmentsIdIndexRoute,
}

const AppShipmentsIdRouteWithChildren = AppShipmentsIdRoute._addFileChildren(
  AppShipmentsIdRouteChildren,
)

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppCarriersCodeRoute: typeof AppCarriersCodeRouteWithChildren
  AppShipmentsIdRoute: typeof AppShipmentsIdRouteWithChildren
  AppShipmentsApproveRoute: typeof AppShipmentsApproveRoute
  AppShipmentsAttentionRoute: typeof AppShipmentsAttentionRoute
  AppShipmentsCompareRoute: typeof AppShipmentsCompareRoute
  AppShipmentsImportRoute: typeof AppShipmentsImportRoute
  AppShipmentsNotesRoute: typeof AppShipmentsNotesRoute
  AppCarriersIndexRoute: typeof AppCarriersIndexRoute
  AppShipmentsIndexRoute: typeof AppShipmentsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppCarriersCodeRoute: AppCarriersCodeRouteWithChildren,
  AppShipmentsIdRoute: AppShipmentsIdRouteWithChildren,
  AppShipmentsApproveRoute: AppShipmentsApproveRoute,
  AppShipmentsAttentionRoute: AppShipmentsAttentionRoute,
  AppShipmentsCompareRoute: AppShipmentsCompareRoute,
  AppShipmentsImportRoute: AppShipmentsImportRoute,
  AppShipmentsNotesRoute: AppShipmentsNotesRoute,
  AppCarriersIndexRoute: AppCarriersIndexRoute,
  AppShipmentsIndexRoute: AppShipmentsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  PasswordRoute: PasswordRoute,
  TotpSetupRoute: TotpSetupRoute,
  DevComponentsRoute: DevComponentsRoute,
  DevMapRoute: DevMapRoute,
  CarriersCodeRecipesVersionEditRoute: CarriersCodeRecipesVersionEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
